import { CartAddEvent } from '@theme/events';

/*
 * Native tea-tasting booking (replaces the appointment app).
 * - Party size + duration select a priced variant (existing variants, unchanged pricing).
 *   Group sizes that are discounted (e.g. 6/7/8) show the full price struck through.
 * - "Select a time" lists owner-managed slots (product metafield custom.tasting_slots).
 * - Booking adds ONLY the tasting variant (date/time + intake answers as line properties)
 *   and opens the cart DRAWER via CartAddEvent (like a normal add) — no page redirect,
 *   no hidden companion line. Rendered only on products with template suffix `tasting-native`.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-tasting-booking]');
  if (!root) return;

  // This section renders below the product section; move the booking UI up into the
  // product info column (where the now-hidden buy box sat) so it reads naturally.
  (function relocate() {
    var info = document.querySelector('.dgt-featured__info');
    if (!info || info.contains(root)) return;
    var anchor = info.querySelector('.dgt-buybox') ||
      info.querySelector('.dgt-flavor') ||
      info.querySelector('.dgt-product-extras') ||
      info.querySelector('.dgt-accordions--policies');
    if (anchor) info.insertBefore(root, anchor);
    else info.appendChild(root);
  })();

  var ADD_URL = root.getAttribute('data-cart-add') || '/cart/add.js';
  var attIdx = parseInt(root.getAttribute('data-att-idx'), 10);
  var durIdx = parseInt(root.getAttribute('data-dur-idx'), 10);

  var variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-tb-variants]').textContent);
  } catch (e) { variants = []; }

  var state = { attendees: null, duration: null, slotDate: null, slotTime: null, slotLabel: null };

  var attBtns = Array.prototype.slice.call(root.querySelectorAll('[data-tb-attendees] [data-tb-att]'));
  var durBtns = Array.prototype.slice.call(root.querySelectorAll('[data-tb-duration] [data-tb-dur]'));
  var priceEl = root.querySelector('[data-tb-price]');
  var openBtn = root.querySelector('[data-tb-open]');
  var slotList = root.querySelector('[data-tb-slot-list]');
  var slotBtns = Array.prototype.slice.call(root.querySelectorAll('[data-tb-slot]'));
  var bookBtn = root.querySelector('[data-tb-book]');
  var errEl = root.querySelector('[data-tb-error]');
  var fields = Array.prototype.slice.call(root.querySelectorAll('[data-tb-prop], [data-tb-required]'));

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function cartSectionIds() {
    var ids = {};
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId) ids[c.dataset.sectionId] = 1;
    });
    return Object.keys(ids).join(',');
  }

  function findVariant() {
    if (state.attendees == null) return null;
    var needDur = durIdx >= 0 && durBtns.length > 0;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (String(v.options[attIdx]) !== String(state.attendees)) continue;
      if (needDur && String(v.options[durIdx]) !== String(state.duration)) continue;
      return v;
    }
    return null;
  }

  // The undiscounted price = party size x the 2-person per-person rate for this length.
  // Group sizes that are cheaper than that (e.g. 6/7/8) are discounted, so we show the
  // full price struck through. Derived from the data, so it needs no hardcoded tiers.
  function fullPriceCents() {
    var n = parseInt(String(state.attendees), 10);
    if (!n) return null;
    var needDur = durIdx >= 0 && durBtns.length > 0;
    var two = null;
    for (var i = 0; i < variants.length; i++) {
      var x = variants[i];
      if (parseInt(String(x.options[attIdx]), 10) !== 2) continue;
      if (needDur && String(x.options[durIdx]) !== String(state.duration)) continue;
      two = x; break;
    }
    if (!two) return null;
    return Math.round(n * (two.price / 2));
  }

  function updatePrice() {
    if (!priceEl) return;
    var v = findVariant();
    if (!v) { priceEl.innerHTML = '—'; return; }
    var full = fullPriceCents();
    if (full && full > v.price) {
      priceEl.innerHTML = '<span class="dgt-tb__price-now">' + money(v.price) +
        '</span> <s class="dgt-tb__price-was">' + money(full) + '</s>';
    } else {
      priceEl.innerHTML = money(v.price);
    }
  }

  function validate() {
    var v = findVariant();
    var ok = !!v && v.available === true && !!state.slotLabel;
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      if (!f.hasAttribute('data-tb-required')) continue;
      if (f.type === 'checkbox') { if (!f.checked) ok = false; }
      else if (!String(f.value || '').trim()) ok = false;
    }
    if (bookBtn) bookBtn.disabled = !ok;
    return ok;
  }

  function selectAttendee(btn) {
    attBtns.forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-pressed', 'false'); });
    btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
    state.attendees = btn.getAttribute('data-tb-att');
    updatePrice(); validate();
  }
  attBtns.forEach(function (b) { b.addEventListener('click', function () { selectAttendee(b); }); });

  function selectDuration(btn) {
    durBtns.forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-pressed', 'false'); });
    btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
    state.duration = btn.getAttribute('data-tb-dur');
    updatePrice(); validate();
  }
  durBtns.forEach(function (b) { b.addEventListener('click', function () { selectDuration(b); }); });
  // Pre-select the first length so a price shows immediately (customer can switch).
  if (durBtns.length) selectDuration(durBtns[0]);

  if (openBtn && slotList) {
    openBtn.addEventListener('click', function () { slotList.hidden = !slotList.hidden; });
  }
  slotBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      slotBtns.forEach(function (x) { x.classList.remove('is-selected'); });
      b.classList.add('is-selected');
      state.slotDate = b.getAttribute('data-slot-date');
      state.slotTime = b.getAttribute('data-slot-time');
      state.slotLabel = b.getAttribute('data-slot-label');
      if (openBtn) openBtn.textContent = state.slotLabel;
      if (slotList) slotList.hidden = true;
      validate();
    });
  });

  fields.forEach(function (f) {
    var ev = (f.tagName === 'SELECT' || f.type === 'checkbox') ? 'change' : 'input';
    f.addEventListener(ev, validate);
  });

  if (bookBtn) {
    bookBtn.addEventListener('click', function () {
      if (!validate()) return;
      var v = findVariant();
      if (!v) return;

      var props = { 'Date': state.slotDate, 'Time': state.slotTime };
      fields.forEach(function (f) {
        if (!f.hasAttribute('data-tb-prop')) return;
        var name = f.getAttribute('data-tb-prop');
        var val = f.type === 'checkbox' ? (f.checked ? 'Yes' : '') : String(f.value || '').trim();
        if (val) props[name] = val;
      });

      bookBtn.disabled = true;
      bookBtn.classList.add('is-busy');
      if (errEl) errEl.hidden = true;

      var sectionIds = cartSectionIds();
      fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: parseInt(v.id, 10),
          quantity: 1,
          properties: props,
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (errEl) { errEl.textContent = 'Sorry — something went wrong adding your booking. Please try again.'; errEl.hidden = false; }
            bookBtn.disabled = false;
            bookBtn.classList.remove('is-busy');
            return;
          }
          // Refresh the cart (morph) + open the drawer like a normal add (no page redirect).
          // Dispatch on document.body, NOT on the cart-items-component: its own handler
          // ignores events whose target is itself (`if (event.target === this) return`),
          // so dispatching there left the drawer empty. Bubbling from body morphs it.
          var comp = document.querySelector('cart-items-component');
          var sid = (comp && comp.dataset.sectionId) || '';
          document.body.dispatchEvent(new CartAddEvent({}, sid, { source: 'dgt-tasting-booking', sections: res.d.sections }));
          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.showDialog === 'function') {
            try { drawer.showDialog(); } catch (e) { /* no-op */ }
          }
          // Gift enforcement may have run before the gift meter rendered into the drawer
          // (the cart was empty on page load) and skipped the $150 auto-gift. Re-fire the
          // event once the gift component is present so the plushie is evaluated + added.
          // Pass the sections again so the cart morphs in place (keeping the sample/gift
          // sections visible) instead of a full re-fetch that can briefly blank them.
          setTimeout(function () {
            document.body.dispatchEvent(new CartAddEvent({}, sid, { source: 'dgt-tasting-booking-followup', sections: res.d.sections }));
          }, 150);
          bookBtn.classList.remove('is-busy');
          bookBtn.disabled = false;
        })
        .catch(function () {
          if (errEl) { errEl.textContent = 'Something went wrong. Please try again.'; errEl.hidden = false; }
          bookBtn.disabled = false;
          bookBtn.classList.remove('is-busy');
        });
    });
  }

  // Preselect the first party size (like the app did) so a price shows immediately.
  if (attBtns.length) selectAttendee(attBtns[0]);
  updatePrice();
  validate();
})();
